/**
 * Globales Einstellungsmodul — wird beim Laden der Settings aus Supabase initialisiert.
 * Alle Format-Funktionen lesen von hier.
 */

// ─── Globale Werte ────────────────────────────────────────────────────────────
let _currency   = 'CHF';
let _dateFormat = 'DD.MM.YYYY';
let _timeFormat = '24h';
let _companyName = '';
let _vatRate    = 0;

/** Wird beim Laden und Speichern der Settings aufgerufen */
export function applySettings(s: {
  currency?: string;
  dateFormat?: string;
  timeFormat?: string;
  companyName?: string;
  vatRate?: number;
}) {
  if (s.currency)    _currency    = s.currency;
  if (s.dateFormat)  _dateFormat  = s.dateFormat;
  if (s.timeFormat)  _timeFormat  = s.timeFormat;
  if (s.companyName !== undefined) _companyName = s.companyName;
  if (s.vatRate !== undefined)     _vatRate     = s.vatRate;
}

/** @deprecated Nutze applySettings */
export function setCurrency(c: string) { if (c) _currency = c; }

export function getCurrency():    string { return _currency; }
export function getCompanyName(): string { return _companyName; }
export function getVatRate():     number { return _vatRate; }

// ─── Geldbetrag ───────────────────────────────────────────────────────────────
export function formatMoney(amount: number, currency?: string): string {
  const cur = currency || _currency;
  const locale = cur === 'CHF' ? 'de-CH' : cur === 'GBP' ? 'en-GB' : 'de-DE';
  return new Intl.NumberFormat(locale, {
    style: 'currency', currency: cur,
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  }).format(amount);
}

// ─── Datum ────────────────────────────────────────────────────────────────────
/**
 * Formatiert ein Datum-String (YYYY-MM-DD) oder Date-Objekt.
 * Respektiert das eingestellte Datumsformat aus den Einstellungen.
 */
export function formatDate(date: string | Date): string {
  const d = typeof date === 'string' ? new Date(date + (date.length === 10 ? 'T12:00' : '')) : date;
  const day   = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year  = d.getFullYear();

  switch (_dateFormat) {
    case 'MM/DD/YYYY': return `${month}/${day}/${year}`;
    case 'YYYY-MM-DD': return `${year}-${month}-${day}`;
    default:           return `${day}.${month}.${year}`; // DD.MM.YYYY
  }
}

/**
 * Formatiert einen Zeit-String (HH:MM) in 12h oder 24h Format.
 */
export function formatTime(time: string): string {
  if (!time) return '';
  const [hStr, mStr] = time.split(':');
  const h = parseInt(hStr, 10);
  const m = mStr ?? '00';
  if (_timeFormat === '12h') {
    const period = h >= 12 ? 'PM' : 'AM';
    const h12 = h % 12 === 0 ? 12 : h % 12;
    return `${h12}:${m} ${period}`;
  }
  return `${String(h).padStart(2, '0')}:${m}`;
}

/**
 * Kombiniert Datum + Zeit im konfigurierten Format.
 */
export function formatDateTime(dateStr: string, timeStr: string): string {
  return `${formatDate(dateStr)} ${formatTime(timeStr)}`;
}
